// eslint-disable-next-line import/prefer-default-export
export const sortBlocks = (blocks) => {
    const source = blocks.map((block, originalIndex) => ({
        block,
        originalIndex,
    }));
    const result = Array(source.length).fill(null);
    const freeBlocks = [];
    const startLocked = [];
    const endLocked = [];

    source.forEach((entry) => {
        if (entry.block.locked === 'start') {
            startLocked.push({
                ...entry,
                position: Math.max(1, entry.block.position),
            });
        } else if (entry.block.locked === 'end') {
            endLocked.push({
                ...entry,
                position: Math.max(1, entry.block.position),
            });
        } else {
            freeBlocks.push(entry);
        }
    });

    const placeFromStart = (entry) => {
        let targetIndex = Math.min(entry.position - 1, result.length - 1);

        while (targetIndex < result.length && result[targetIndex] !== null) {
            targetIndex += 1;
        }

        if (targetIndex < result.length) {
            result[targetIndex] = entry.block;
            return true;
        }

        return false;
    };

    const placeFromEnd = (entry) => {
        let targetIndex = Math.max(result.length - entry.position, 0);

        while (targetIndex >= 0 && result[targetIndex] !== null) {
            targetIndex -= 1;
        }

        if (targetIndex >= 0) {
            result[targetIndex] = entry.block;
            return true;
        }

        return false;
    };

    startLocked
        .sort((a, b) => a.position - b.position || a.originalIndex - b.originalIndex)
        .forEach((entry) => {
            if (!placeFromStart(entry)) {
                freeBlocks.push(entry);
            }
        });

    endLocked
        .sort((a, b) => a.position - b.position || a.originalIndex - b.originalIndex)
        .forEach((entry) => {
            if (!placeFromEnd(entry)) {
                freeBlocks.push(entry);
            }
        });

    freeBlocks
        .sort((a, b) => a.originalIndex - b.originalIndex)
        .forEach((entry) => {
            const targetIndex = result.findIndex((block) => block === null);
            if (targetIndex > -1) {
                result[targetIndex] = entry.block;
            }
        });

    return result.filter(Boolean);
};
